import React, {Fragment} from 'react';
import {Form, Input} from 'semantic-ui-react';

const BlacklistForm = ({
  blacklist,
  handleTextChanged,
  isReadOnly,
  isBeingEdited,
}) => {
  return (
    <Fragment>
      <Form.Group widths="equal">
        <Form.Field
          id="form-create-firstName"
          name="firstName"
          disabled={isReadOnly}
          value={blacklist.firstName}
          onChange={handleTextChanged}
          control={Input}
          label="First Name"
        />
        <Form.Field
          id="form-create-lastName"
          name="lastName"
          disabled={isReadOnly}
          value={blacklist.lastName}
          onChange={handleTextChanged}
          control={Input}
          label="Last Name"
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          id="form-create-emailAddress"
          name="emailAddress"
          disabled={isBeingEdited}
          value={blacklist.emailAddress}
          onChange={handleTextChanged}
          label="Email Address"
          control={Input}
        />
        <Form.Field
          id="form-create-customer"
          name="customer"
          disabled={isReadOnly}
          value={blacklist.customer}
          onChange={handleTextChanged}
          label="Customer"
          control={Input}
        />
      </Form.Group>
    </Fragment>
  );
};

export default BlacklistForm;
